/* eslint-disable react/destructuring-assignment */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { Input, Button } from '../../components';
import { insereDados, clear2to8 } from '../../store/actions/questionario-actions';

function Main(props) {
  const array = [
    { AL: 'Alagoas' },
    { value: 'AC', label: 'Acre' },
    { value: 'AP', label: 'Amapá' },
    { value: 'AM', label: 'Amazonas' },
    { value: 'BA', label: 'Bahia' },
    { value: 'CE', label: 'Ceará' },
    { value: 'DF', label: 'Distrito Federal' },
    { value: 'ES', label: 'Espírito Santo' },
    { value: 'GO', label: 'Goiás' },
    { value: 'MA', label: 'Maranhão' },
    { value: 'MT', label: 'Mato Grosso' },
    { value: 'MS', label: 'Mato Grosso do Sul' },
    { value: 'MG', label: 'Minas Gerais' },
    { value: 'PA', label: 'Pará' },
    { value: 'PB', label: 'Paraíba' },
    { value: 'PR', label: 'Paraná' },
    { value: 'PE', label: 'Pernambuco' },
    { value: 'PI', label: 'Piauí' },
    { value: 'RJ', label: 'Rio de Janeiro' },
    { value: 'RN', label: 'Rio Grande do Norte' },
    { value: 'RS', label: 'Rio Grande do Sul' },
    { value: 'RO', label: 'Rondônia' },
    { value: 'RR', label: 'Roraima' },
    { value: 'SC', label: 'Santa Catarina' },
    { value: 'SP', label: 'São Paulo' },
    { value: 'SE', label: 'Sergipe' },
    { value: 'TO', label: 'Tocantins' },
  ];
  const onChange = (event) => {
    const { name, value } = event.target;
    props.insereDados(name, value);
  };
  const [valid, setValid] = useState({});
  const schema = Yup.object().shape({
    localizacao: Yup.string()
      .min(2, 'Esse campo é obrigatório.')
      .required('Esse campo é obrigatório.'),
    uf: Yup.string()
      .required('O campo UF é obrigatório'),
  });
  const goProximaQuestao = (e) => {
    e.preventDefault();
    let dados = {};
    if (props.dados.localizacao === 'brasil') {
      dados = {
        localizacao: props.dados.localizacao,
        uf: props.dados.uf,
      };
    } else {
      dados = {
        localizacao: props.dados.localizacao,
        uf: 'n/d',
      };
    }

    schema.validate(dados).then(
      () => {
        props.history.push('/questao31');
      },
    ).catch((err) => {
      setValid(err);
    });
  };
  const clear = async () => {
    await props.clear2to8();
  };
  useEffect(() => {
    clear();
    // eslint-disable-next-line
  }, []);
  return (
    <form onSubmit={goProximaQuestao}>
      <h3>2 - De qual localidade você está registrando a denúncia?</h3>
      <Input
        onChange={onChange}
        type="radio"
        name="localizacao"
        checked={props.dados.localizacao === 'brasil'}
        value="brasil"
      />
      <span>Brasil </span>
      {props.dados.localizacao === 'brasil' ? (
        <>
          <span>(informe a UF): </span>
          <select
            name="uf"
            onChange={onChange}
          >
            {array.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
          </select>
        </>
      ) : (null)}

      <br />

      <Input
        onChange={onChange}
        type="radio"
        checked={props.dados.localizacao === 'estrangeiro'}
        name="localizacao"
        value="estrangeiro"
      />
      <span>País estrageiro</span>
      <br />
      <span className="worning">{valid.errors && valid.errors[0]}</span><br />
      <Button
        type="button"
        onClick={() => props.history.push('/')}
      >
        QUESTÃO ANTERIOR
      </Button>
      <Button
        type="submit"
        className="button"
      >PRÓXIMA QUESTÃO
      </Button>
    </form>
  );
}
const mapStateToProps = state => (
  {
    dados: state.QuestionarioReducers,
  }
);
export default connect(mapStateToProps, { insereDados, clear2to8 })(Main);
